<app-retracement-menu></app-retracement-menu>

<div  *ngIf="canShow" class="evantsPan my-css-class left-bar">
    <app-eventsTabs *ngIf="canShow"></app-eventsTabs>
</div>

<div  *ngIf="canShow" class="strikePan my-css-class left-bar">
    
</div>

<div [ngStyle]="targetStyle()" id="chartWrapper">

</div>
<!--
<div style="width:100%; height:20%; min-height:100px" id="chartWrapperSma"></div>
-->
